import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatTrackingTimezone',
})
export class FormatTrackingTimezonePipe implements PipeTransform {
  transform(tzString: string | undefined | null, offsetMinutes?: number | null): string {
    if (!tzString) return '';
    try {
      const date = new Date();
      const parts = new Intl.DateTimeFormat('en-US', { timeZone: tzString, timeZoneName: 'short' }).formatToParts(date);
      const shortName = parts.find((p) => p.type === 'timeZoneName')?.value || tzString;

      let diffMinutes = offsetMinutes;

      if (diffMinutes === undefined || diffMinutes === null) {
        const tzDate = new Date(date.toLocaleString('en-US', { timeZone: tzString }));
        const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
        diffMinutes = Math.round((tzDate.getTime() - utcDate.getTime()) / 60000);
      }

      const sign = diffMinutes >= 0 ? '+' : '-';
      const abs = Math.abs(diffMinutes);
      const h = Math.floor(abs / 60);
      const m = abs % 60;
      const gmt = m > 0 ? `GMT${sign}${h}:${m.toString().padStart(2, '0')}` : `GMT${sign}${h}`;

      return `${shortName} (${gmt})`;
    } catch {
      return tzString;
    }
  }
}
